module.exports = __webpack_public_path__ + "img/tools.c8acc02d.svg";